export const ObservableStencilWrapper = (observable) => {
  return {
    watch: (...args) => {
      observable.watch(...args);
    },
    stencilProp: () => {
      return observable.valueOf();
    },
  };
};
